import React, { useCallback } from 'react';

import ProtocolForm from '../../../../views/Protocol/form';
import { DynamicLayoutModal } from 'components/Modal/DynamicLayoutModal';

const ProtocolModal = ({
  isModalOpen,
  onModalToggle,
  defaultFormData,
  createdFrom = '',
  fatherProtocol = undefined,
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  return (
    <DynamicLayoutModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Protocolo de atendimento"
      showCloseButton={false}
      centered={true}
      backdrop={true}
      closeModal={closeModal}
      hasDynamicLayout={true}
      minWidth={300}
      maxWidth={800}
      isToClickOutsideClose={false}
      {...props}
    >
      <ProtocolForm
        modalActions={{ closeModal, defaultFormData }}
        selectedRecordTypeId={defaultFormData?.recordTypeId}
        createdFrom={createdFrom}
        fatherProtocol={fatherProtocol}
      />
    </DynamicLayoutModal>
  );
};

export default ProtocolModal;
